import { render, staticRenderFns } from "./amd-promo-hero.vue?vue&type=template&id=036d3cda&scoped=true&"
import script from "./amd-promo-hero.vue?vue&type=script&lang=js&"
export * from "./amd-promo-hero.vue?vue&type=script&lang=js&"
import style0 from "./amd-promo-hero.vue?vue&type=style&index=0&id=036d3cda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036d3cda",
  null
  
)

export default component.exports